import { PlanVariantDetailsCardProps } from '../../types/components/pricing/PlanVariantDetailsCard';
import { PlanVariantResponse } from '../../types/api/SubscriptionTypes';

import { useState } from 'react';

import DiscountBanner from './DiscountBanner';
import PlanVariantSelectionButtons from './PlanVariantSelectionButtons';
import PlanPriceTag from '../shared/PlanPriceTag';
import SelectPlanButton from './SelectPlanButton';
import PlanFeatures from './PlanFeatures';
import PlanRestrictions from './PlanRestrictions';

import { EnterpriseIconOutline } from '../../modules/Icons';

export const freePlanBackground = '#0B1113';
export const paidPlanBackground = 'linear-gradient(166deg, #001F2C 0%, #00151E 100%)';

const PlanVariantDetailsCard: React.FC<PlanVariantDetailsCardProps> = ({
  planType,
  planVariants,
  selectedInterval,
  planCardDetails,
  freePlan,
  licenseId,
  displayContactSalesUI,
  testId,
}) => {
  const [selectedPlanVariant, setSelectedPlanVariant] = useState<PlanVariantResponse>();

  const background = freePlan ? freePlanBackground : paidPlanBackground;
  const displayPlanVariantSelectionButtons = (): boolean => !freePlan && !displayContactSalesUI;

  return (
    <div
      className="flex flex-col max-w-[396px] px-6 md:px-[40px] xl:px-[30px] 2xl:px-[40px] pt-[50px] pb-[70px] rounded-[10px] relative overflow-hidden"
      style={{ background }}
      cy-test-id={testId || 'plan-variant-details-card'}
    >
      <DiscountBanner freeForever={freePlan} />
      <div className="flex flex-col items-center rounded-[10px] gap-2 ">
        <h3 className="inter text-center text-[36px] font-[600] leading-[40px]" cy-test-id="name">
          {planCardDetails.name}
        </h3>
        <p className="text-center text-a-gray text-[16px] leading-[24px] md:h-[48px] lg:mb-0" cy-test-id="description">
          {planCardDetails.description}
        </p>
        {freePlan && <div className="h-[100px] md:h-[180px]" cy-test-id="free-plan-placeholder"></div>}
        {displayContactSalesUI && <EnterpriseIconOutline cy-test-id="enterprise-icon" className="w-[114px] h-[189px] my-[41px] md:my-[52px]" />}
        {
          displayPlanVariantSelectionButtons() &&
          <div className="md:h-[180px]">
            <PlanVariantSelectionButtons
              planVariants={planVariants}
              selectedPlanVariant={selectedPlanVariant}
              setSelectedPlanVariant={setSelectedPlanVariant}
              interval={selectedInterval}
            />
          </div>
        }
        {
          !displayContactSalesUI &&
          <div className="h-[105px]">
            <PlanPriceTag
              plan={selectedPlanVariant}
              freeForever={freePlan}
              alignment="vertical"
              shortenIntervalStrings={true}
            />
          </div>
        }
        <SelectPlanButton
          freePlan={freePlan}
          displayContactSalesUI={displayContactSalesUI}
          selectedPlanVariant={selectedPlanVariant}
          licenseId={licenseId}
          planVariants={planVariants}
        />
      </div>
      <hr className="w-full h-px my-4 bg-gray-700 border-0"></hr>
      <div className="flex flex-col gap-4">
        <PlanFeatures
          planType={planType}
          selectedPlanVariant={selectedPlanVariant}
          interval={selectedInterval}
          features={planCardDetails.features}
          licenseId={licenseId}
        />
        <PlanRestrictions
          restrictions={planCardDetails.restrictions}
        />
      </div>
    </div>
  )
}

export default PlanVariantDetailsCard;
